import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.css';
import  TextType  from '../../../../components/TextType';
import { QuestionActionButtons } from '../QuestionActionButtons';
export const Message = ({ 
  isUserMessage, 
  msg, 
  children, 
  onRenderMessage, 
  isLastBackendMessage, 
  forceTypingAnimation = false,
  onRespond,
  onSkip,
  onTypingComplete
}) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (onRenderMessage) {
      onRenderMessage();
    }
  }, [onRenderMessage])
  
  const shouldAnimateTyping =
    !isUserMessage &&
    msg.backend &&
    (isLastBackendMessage || forceTypingAnimation) &&
    !msg.disableTypingAnimation &&
    !msg.isLoadingMessage;

  const shouldShowActionButtons = !isUserMessage && 
    isLastBackendMessage && 
    msg.component != null && 
    (msg.component === 'ProductImageSelector' || msg.component === 'VisualStyleSelector') &&
    onRespond &&
    onSkip;
  
  return(
    <div className={styles.message_container}>
      <div className={`${styles.message_wrapper} ${isUserMessage ? styles.flex_wrapper_reverse : ''}`}>                 
        {/* <div className={styles.message_avatar}>
          {isUserMessage ? (
            <Avatar 
              imageUrl={userImageUrl}
              name={userName}
              size="medium"
              className={styles.avatar_user}
            />
          ) : (
            <Avatar
              size="medium"
            />
          )}
        </div>  */}
        <div className={isUserMessage ? styles.frontend_message : styles.backend_message}>
          {shouldAnimateTyping ? (
            <TextType
              key={`texttype-${msg.stepOrder}-${msg._origMessageOrder ?? msg.messageOrder}-${String(msg.backend).slice(0, 20)}`}
              text={String(msg.backend || '')}
              typingSpeed={20}
              pauseDuration={0}
              showCursor={false}
              loop={false}
              as="p"
              onTypingComplete={onTypingComplete}

            />
          ) : (
            <p>
              {msg.frontend || msg.backend}
              {(msg.isLoadingMessage || msg.isApprovalLoadingMessage) && (
                <span className={styles.approvalSpinner} />
              )}
            </p>
          )}
          {msg.imageUrls && msg.imageUrls.length > 0 && (
            <div className={styles.messageImages}>
              {msg.imageUrls.map((imageUrl, index) => (
                <img 
                  key={index}
                  src={imageUrl} 
                  alt={t('chatsocket.message.alt')} 
                  className={styles.messageImage}
                />
              ))}
            </div>
          )}
        </div>

      </div>
      {shouldShowActionButtons && (
        <QuestionActionButtons 
          onRespond={onRespond}
          // hideSkipBtn={msg.messageOrder === 5}
          onSkip={onSkip}
          hideRespondBtn={msg.component === 'ProductImageSelector' || msg.component === 'VisualStyleSelector'}
        />
      )}
      {children}
    </div>

  )
}